module.exports = __webpack_public_path__ + "img/existing-resources-3-1.341f1132.jpg";